// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const toggleReportsAccordion = () => ({
    type: actions.TOGGLE_PRODUCT_REPORTS_ACCORDION
});



// WEBPACK FOOTER //
// ./src/product/shared/action-creators/reports-accordion.js